import { render, staticRenderFns } from "./KvmDualSparkline.vue?vue&type=template&id=17cf213c&scoped=true&"
import script from "./KvmDualSparkline.vue?vue&type=script&lang=js&"
export * from "./KvmDualSparkline.vue?vue&type=script&lang=js&"
import style0 from "./KvmDualSparkline.vue?vue&type=style&index=0&id=17cf213c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17cf213c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17cf213c')) {
      api.createRecord('17cf213c', component.options)
    } else {
      api.reload('17cf213c', component.options)
    }
    module.hot.accept("./KvmDualSparkline.vue?vue&type=template&id=17cf213c&scoped=true&", function () {
      api.rerender('17cf213c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/services/hosting/kvm/KvmDualSparkline.vue"
export default component.exports